import { getPaymentFlow } from './paymentLanding/returnLink'

// Keep the payment return page outside portal authentication, SDKs and telemetry.
if (getPaymentFlow(window.location.pathname)) {
  const referrer = document.createElement('meta')
  referrer.name = 'referrer'
  referrer.content = 'no-referrer'
  document.head.appendChild(referrer)
  void import('./paymentLanding/bootstrap')
} else {
  void import('./bootstrapPortal')
}

export {}
